export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/favicons/ms-icon-144x144.png"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/favicons/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/favicons/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/favicons/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/favicons/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/favicons/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/favicons/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/favicons/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/favicons/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicons/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/favicons/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicons/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicons/favicon-16x16.png"},{"rel":"manifest","href":"/manifest.json"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"\nwindow._mfq = window._mfq || [];\n(function() {\n    var mf = document.createElement(\"script\");\n    mf.type = \"text/javascript\"; mf.defer = true;\n    mf.src = \"//cdn.mouseflow.com/projects/bc2dad04-6ce4-4b0a-8139-f5c7c85109fe.js\";\n    document.getElementsByTagName(\"head\")[0].appendChild(mf);\n})();\n            ","tagPosition":"bodyClose"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true